import {ThemeType, ThemeTypographyName} from '../../../theme';
import {BaseFontProps} from '../../base/types';

export const mapFontToBaseProperties = (
  theme: ThemeType,
  font: ThemeTypographyName,
): BaseFontProps => {
  return theme.typography[font];
};
